export enum Alignments {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

export type Alignment =`${Alignments}`;

export const alignmentStyleClasses: Map<string, string> = new Map([
  [Alignments.CENTER, 'align-center'],
  [Alignments.LEFT, 'align-left'],
  [Alignments.RIGHT, 'align-right'],
]);

